import { render, staticRenderFns } from "./DocumentDetailListPrevious.vue?vue&type=template&id=5ce2805e&scoped=true"
import script from "./DocumentDetailListPrevious.vue?vue&type=script&lang=js"
export * from "./DocumentDetailListPrevious.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce2805e",
  null
  
)

export default component.exports